import { getCoreRowModel, getFilteredRowModel, useReactTable } from '@tanstack/react-table';
import { useApiQuery } from '../../../infra/api';
import { endpoints } from './network';
import { useClientListFilterState } from './use-client-list-filter-state';
import { useReorderState } from './use-reorder-state';
import { currentViewColumns, historyViewColumns } from './columns';
import { getSessionShop, useSession } from '../../../infra/session';
var useCurrentTable = function (_a) {
    var filterState = _a.filterState, shop = _a.shop, date = _a.date;
    var data = useApiQuery({
        endpoint: endpoints.walkInListCurrentQuery,
        payload: {
            shopId: shop.id,
            timezone: shop.timezone,
            date: date,
        },
    }).data;
    var reorderState = useReorderState({ clientFilter: filterState.clientFilter });
    var table = useReactTable({
        data: data || [],
        columns: currentViewColumns,
        getCoreRowModel: getCoreRowModel(),
        state: {
            globalFilter: filterState.clientFilter,
        },
        onGlobalFilterChange: filterState.setClientFilter,
        globalFilterFn: filterState.filterClientsFn,
        getFilteredRowModel: getFilteredRowModel(),
        meta: { reorderState: reorderState },
    });
    return {
        table: table,
        dataLength: (data === null || data === void 0 ? void 0 : data.length) || 0,
    };
};
var useHistoryTable = function (_a) {
    var filterState = _a.filterState, shop = _a.shop, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    date = _a.date;
    var data = useApiQuery({
        endpoint: endpoints.walkInListHistoryQuery,
        payload: {
            shopId: shop.id,
            date: date,
            timezone: shop.timezone,
        },
    }).data;
    var table = useReactTable({
        data: data || [],
        columns: historyViewColumns,
        getCoreRowModel: getCoreRowModel(),
        state: {
            globalFilter: filterState.clientFilter,
        },
        onGlobalFilterChange: filterState.setClientFilter,
        globalFilterFn: filterState.filterClientsFn,
        getFilteredRowModel: getFilteredRowModel(),
    });
    return {
        table: table,
        dataLength: (data === null || data === void 0 ? void 0 : data.length) || 0,
    };
};
export var useListState = function (_a) {
    var activeView = _a.activeView, date = _a.date;
    var filterState = useClientListFilterState({ activeView: activeView });
    var session = useSession().data;
    var shop = getSessionShop(session);
    var currentTable = useCurrentTable({
        filterState: filterState,
        shop: shop,
        date: date,
    });
    var historyTable = useHistoryTable({
        filterState: filterState,
        shop: shop,
        date: date,
    });
    if (activeView === 'current') {
        return {
            table: currentTable.table,
            totalClients: currentTable.dataLength,
            clientFilter: filterState.clientFilter,
            setClientFilter: filterState.setClientFilter,
        };
    }
    return {
        table: historyTable.table,
        totalClients: historyTable.dataLength,
        clientFilter: filterState.clientFilter,
        setClientFilter: filterState.setClientFilter,
    };
};
